import { useHashNavigation } from "./useHashNavigation";
import { useAvailableLines } from "./useAvailableLines";
import { useNotEscaletedLinesNext } from "./useNotEscaletedLinesNext";
import { useNotEscaletedLinesToday } from "./useNotEscaletedLinesToday";
import { useEscaletedLinesToday } from "./useEscaletedLinesToday";
import { useAlertsN1 } from "./useAlertsN1";
import { useAlertsN2 } from "./useAlertsN2";
import { useAlertsN3 } from "./useAlertsN3";

export function useHashsSync() {
    useHashNavigation();
    useAvailableLines();
    useNotEscaletedLinesNext();
    useNotEscaletedLinesToday();
    useEscaletedLinesToday();
    useAlertsN1();    
    useAlertsN2();
    useAlertsN3();
}